import React from 'react';
import './RibbonMenu.css';
import { useState, useRef, useEffect } from 'react';

const RibbonMenu = ({
  currentPage,
  totalPages,
  onAddPage,
  onPrevPage,
  onNextPage,
  onPageChange,
  onDeletePage,
  onPageType,
  operation,
  filename,
  x,
  y,
  selected,
  pageId,
  devices,
  pageWidth,
  pageType,
  hoverEnter,
  hoverLeave
}) => {

  const [id,setId] = useState("");
  const [z, setZ] = useState(-1);
  const [type, setType] = useState("");
  const [midVis, setMidVis] = useState(false);
  const [lType, setLType] = useState(false);
  const [linkId, setLinkId] = useState("");
  const [linkFile, setLinkFile]=useState("");
  // const [pageType, setPageType]=useState("Desktop");


  useEffect(()=>{

      // Find initial device type
      const initialDevice = devices.find(
        device => pageWidth >= device.minWidth && pageWidth <= device.maxWidth
      );

      // setPageType(initialDevice.name);

  },[pageWidth]);

  useEffect(()=>{
    if(selected?.length == 1)
    {
      setId(selected[0].id);
      setZ(selected[0].zIndex);
      setType(selected[0].type)
      setMidVis(true);

      if(selected[0].type === 'Link')
      {
        setLinkId(selected[0].linkId);
        let linkFile = selected[0].linkFile;
        setLinkFile(linkFile);
        setLType(true);
      }
      else
      {
        setLType(false);
      }
    }
    else
    {
      setMidVis(false);
    }

  },[selected])

  let devId=pageId.split("_")[1];


  const canDeletePage = (currentPage > 1 && currentPage==totalPages) || devId > 0 ;
  const allDisabled = operation === 'pline' || operation === 'freehand' || operation === 'svgtext' || operation === 'bezier'; 

  let pageIdTrunc = pageId.slice(-7);

    function renderInfo ()
    {
      return (
        <div className="ribbon-middle">            

          {/* Page Type Dropdown */}
          <span>
            Device Type:{" "}
            <select value={pageType} 
              onChange={onPageType} 
              disabled={allDisabled}
              data-help="addDevice"
              onMouseEnter={(e) => hoverEnter(e)}
              onMouseLeave={(e) => hoverLeave(e)}
              >
              {devices.map(device => (
                <option key={device.name} value={device.name}>
                  {device.name.charAt(0).toUpperCase() + device.name.slice(1)} ({device.minWidth}–{device.maxWidth}px)
                </option>
              ))}
            </select>
          </span>
          {/*
        </span>
          <span className="ribbon-meta">
          Page Type:{" "}
          <select value={pageType} onChange={onPageType}>
            <option value="extraSmall">Extra Small (mobile)</option>
            <option value="small">Small (mobile large)</option>
            <option value="medium">Medum (tablet)</option>
            <option value="large">Large (laptop)</option>
            <option value="extraLarge">Extra Large (Desktop)</option>

          </select>
            </span> */}
        <span className="ribbon-meta">Id: {pageIdTrunc}</span>
        </div>
      );
    }

    function renderPageInfo()
    {

      
      if(devId > 0)
      {

        return (

          <div className="ribbon-page-info-red">
              <span>{currentPage}</span>
              <span>of {totalPages}</span>
          </div>              
        );
      }
      

      return (
          <div className="ribbon-page-info">
          <span>{currentPage}</span>
          <span>of {totalPages}</span>
        </div>              
      );


    }

  return (
    <div className="ribbon-menu">
      <div className="ribbon-left">
        <button className="ribbon-button" 
              onClick={onAddPage} 
              disabled={currentPage < 1 || allDisabled} 
              title="Create a new extra small page"
              data-help={"addPage"}
              onMouseEnter={(e) => { 
                hoverEnter(e)}}
              onMouseLeave={(e) => { 
                  hoverLeave(e) 
                }}
        >+</button>
        <button className="ribbon-button" 
            onClick={onPrevPage} 
            disabled={currentPage <= 1 || allDisabled}
            title="Go to the previous page"
            data-help={"prevPage"}
            onMouseEnter={(e) => { 
              hoverEnter(e)}}
            onMouseLeave={(e) => { 
                hoverLeave(e) 
              }}
            >
              ◀
        </button>
        <button className="ribbon-button" 
            onClick={onNextPage} 
            title="Go to the next page"
            disabled={currentPage >= totalPages || allDisabled}
            data-help={"nextPage"}
            onMouseEnter={(e) => { 
              hoverEnter(e)}}
            onMouseLeave={(e) => { 
                hoverLeave(e) 
              }}
        >▶</button>

        <button
          className="ribbon-button delete-button"
          onClick={onDeletePage}
          disabled={!canDeletePage}
          title="Delete Current Page"
          data-help={"deletePage"}
          onMouseEnter={(e) => { 
            hoverEnter(e)}}
          onMouseLeave={(e) => { 
              hoverLeave(e) 
            }}

        >
          🗑️
        </button>
        {renderPageInfo()}

      </div>
        {renderInfo()}


      <div className="ribbon-right">
        <span className="ribbon-meta">File: {filename || 'Untitled'}</span>
        <span className="ribbon-meta">Op: {operation}</span>
        <span className="ribbon-meta">X: {x}, Y: {y}</span>
      </div>
    </div>
  );
};

export default RibbonMenu;


